import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../../services/api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-aggiungi-utente-backoffice',
  templateUrl: './aggiungi-utente-backoffice.component.html',
  styleUrl: './aggiungi-utente-backoffice.component.css'
})
export class AggiungiUtenteBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService, private router: Router) { }

  formUtente!: FormGroup;

  tipi: { tipo: string }[] = [
    { tipo: 'Operatore' },
    { tipo: 'Amministratore' }    
  ]

  ngOnInit(): void {    

    this.formUtente = new FormGroup({
      username: new FormControl(null, Validators.required),
      email: new FormControl(null, Validators.email),
      password: new FormControl(null, [Validators.required, Validators.minLength(4)]),
      confirm_password: new FormControl(null, [Validators.required, Validators.minLength(4)]),
      tipo: new FormControl(null, Validators.required)
    },
      {
        validators: this.passwordMatchValidator
      }
    )
  }

  passwordMatchValidator(control: AbstractControl) {
    return control.get('password')?.value === control.get('confirm_password')?.value ? null : { mismatch: true }
  }
  
  onSubmit() {

    let utente = {
      username: this.formUtente.get('username')?.value,
      email: this.formUtente.get('email')?.value || '',
      password: this.formUtente.get('password')?.value,
      tipo: this.formUtente.get('tipo')?.value.tipo 
    }
    
    this.apiService.addUtente(utente).subscribe({
      next: (data) => this.apiService.setUtenti(),
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => { this.router.navigate(['/backoffice/utenti'])}
    })
  }
}

